import { render } from "./DraggablePopup.vue?vue&type=template&id=15686088&ts=true"
import script from "./DraggablePopup.vue?vue&type=script&lang=ts"
export * from "./DraggablePopup.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__